import { useState } from "react";

import { Markdown } from "./markdown";

interface MarkdownEditorProps {
	value: string;
	onChange: (value: string) => void;
	rows?: number;
	maxLength?: number;
	placeholder?: string;
	testId?: string;
}

/**
 * Éditeur de texte Markdown : onglets « Écrire » / « Aperçu » (rendu formaté).
 * Utilisé pour les descriptions produit (le contenu est stocké en Markdown).
 */
export function MarkdownEditor({
	value,
	onChange,
	rows = 6,
	maxLength,
	placeholder,
	testId,
}: MarkdownEditorProps) {
	const [tab, setTab] = useState<"write" | "preview">("write");

	const tabBtn = (t: "write" | "preview", label: string) => (
		<button
			type="button"
			onClick={() => setTab(t)}
			style={{
				border: "none",
				borderRadius: 5,
				padding: "3px 10px",
				fontSize: 12,
				cursor: "pointer",
				fontWeight: tab === t ? 600 : 400,
				background: tab === t ? "var(--a-surface)" : "transparent",
				color: tab === t ? "var(--a-ink)" : "var(--a-muted)",
				boxShadow: tab === t ? "0 1px 2px rgba(0,0,0,0.08)" : "none",
			}}
		>
			{label}
		</button>
	);

	return (
		<div
			style={{
				border: "1px solid var(--a-border)",
				borderRadius: 8,
				overflow: "hidden",
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 4,
					padding: 4,
					borderBottom: "1px solid var(--a-border)",
					background: "var(--a-surface-2)",
				}}
			>
				{tabBtn("write", "Écrire")}
				{tabBtn("preview", "Aperçu")}
				<span
					style={{
						marginLeft: "auto",
						fontSize: 11,
						color: "var(--a-muted)",
						paddingRight: 6,
					}}
				>
					Markdown
				</span>
			</div>
			{tab === "write" ? (
				<textarea
					className="aform-i"
					style={{
						border: "none",
						borderRadius: 0,
						display: "block",
						width: "100%",
						resize: "vertical",
					}}
					rows={rows}
					maxLength={maxLength}
					placeholder={placeholder}
					value={value}
					data-testid={testId}
					onChange={(e) => onChange(e.target.value)}
				/>
			) : (
				<div
					style={{
						padding: 12,
						minHeight: rows * 20,
						maxHeight: 360,
						overflow: "auto",
					}}
				>
					{value.trim() ? (
						<Markdown>{value}</Markdown>
					) : (
						<span className="muted" style={{ fontSize: 12 }}>
							(Rien à prévisualiser)
						</span>
					)}
				</div>
			)}
		</div>
	);
}
